
import { Button } from "@/components/ui/button";
import { Tooltip } from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";

interface RegenerateButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const RegenerateButton: React.FC<RegenerateButtonProps> = ({ onClick, disabled }) => {
  return (
    <Tooltip title="Regenerate Response">
      <Button
        sx={{
          textTransform: "capitalize",
          fontSize: "0.25rem",
        }}
        variant={"outline"}
        onClick={onClick}
        disabled={disabled}
        startIcon={<ReplayIcon />}
        className={`text-xs p-2 ml-2`}
      >
        Regenerate Output
      </Button>
    </Tooltip>
  );
};

export default RegenerateButton;
